import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { Contact, CreateContact } from './contacts';

class ClientContacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      create : false
    }
  }
  componentDidMount() {
    if(this.props.client._id)
      this.props.fetchContacts(this.props.client._id);
  }
  componentWillUpdate(nextProps, nextState) {
    if(nextProps.client != this.props.client) {
      this.props.fetchContacts(nextProps.client._id);
    }
  }
  componentWillUnmount() {
    this.props.clearContacts();
  }
  render() {
    const { downloaded_contacts, client } = this.props;

    if(!client) {
      return <noscript />
    }
    return (
      <section className="panel animated fadeInUp">
          <header className="panel-heading">
            <div className="panel-actions">
              <a href="#" className="panel-action panel-action-toggle" data-panel-toggle></a>
            </div>

            <h2 className="panel-title">
              <span className="label label-primary label-md text-weight-normal va-middle mr-md">{downloaded_contacts.length}</span>
              <span className="va-middle">Contacts</span>
            </h2>
          </header>
          <div className="panel-body">
            <div className="content">
              <ul className="simple-user-list">
                {this.props.downloaded_contacts.map( (contact, index) => <li key={index}><Contact contact={contact} /></li> )}
              </ul>
              <hr className="dotted short"/>
              <CreateContact client={client._id} />
            </div>
          </div>
        </section>
    );
  }
}

const mapStateToProps = ({contacts}) => ({...contacts});

ClientContacts.propTypes = {
  client : PropTypes.object.isRequired
}

export default connect(mapStateToProps, Actions)(ClientContacts);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-contacts.js